import type { ContractVersionPreviewView } from "@closer/shared";
import { useQuery } from "@tanstack/react-query";

import { api } from "../../lib/apiClient";
import { useAuth } from "../../lib/authContext";
import { tenantKey } from "../../lib/tenantQuery";

/**
 * MÜVEKKİL ALANI TEMSİLCİSİNİN GÜNCEL SÜRÜMÜ (Client Area §5).
 *
 * ### ⚠ TEK SORGU, İKİ TÜKETİCİ
 *
 * Aynı yükü hem belge kartı hem öneri yüzeyi istiyor: kart metni gösteriyor, öneri yüzeyi
 * aynı sürümü ÖNERİNİN TABANI yapıyor. İki ayrı sorgu yazsaydık ekran iki kez ağa çıkar ve
 * daha kötüsü iki taraf farklı sürüm görebilirdi — kullanıcı v4'ü okuyup v3'e öneri verirdi.
 * Anahtar ortak olduğu için TanStack Query iki çağrıyı tek istekte birleştiriyor.
 *
 * ### ⚠ 404 = "bu yüzey sende yok", arıza değil
 *
 * Uç yalnız Müvekkil Alanı temsilcisine açık. Katılımcı organizasyon 404 alıyor; `retry`
 * kapalı ve çağıran taraf `data` yokluğunu sessizce ele alıyor.
 */
export function useSharedCurrentVersion(contractId: string) {
  const { activeTenantId } = useAuth();
  const tenantId = activeTenantId!;
  return useQuery({
    queryKey: tenantKey(tenantId, "paylasilan-sozlesme", contractId, "belge"),
    enabled: activeTenantId !== null,
    retry: false,
    queryFn: async () =>
      (
        await api<ContractVersionPreviewView>(
          `/api/shared-contracts/${contractId}/current-version/preview`,
          { tenantId },
        )
      ).data,
  });
}
